export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}
